import { Funds } from '@fortem-monorepo/web-sdk'

export const queryKeys = {
  funds: ['funds', 'list'],
  holidays: (params: Funds.GetFundHolidaysParams) => ['funds', 'holidays', params],
  nav: (params: Funds.GetNavParams) => ['funds', 'nav', params],
  softNav: (params: Funds.GetSoftNavParams) => ['funds', 'soft-nav', params],
  softNavBreakdown: (params: Funds.GetSoftNavBreakdownParams) => ['funds', 'soft-nav', 'breakdown', params],
  softNavPnL: (params: Funds.GetSoftNavPnLParams) => ['funds', 'soft-nav', 'pnl', params],
  positions: (params: Funds.GetPositionsParams) => ['funds', 'positions', params],
  positionsPnL: (params: Funds.GetPositionsPnLParams) => ['funds', 'positions', 'pnl', params],
}
